import { RebillySubscription } from '@xyo-network/api-checkout-apollo'

function isCanceledOrChurned(subscription: RebillySubscription) {
  const status = subscription?.status
  return status === 'canceled' || status === 'churned' || status === 'abandoned' || status === 'abandoned'
}

export default isCanceledOrChurned
